import React, { Fragment } from 'react';
import { StepStage } from '@philips-internal/oswald-ui-constants';
import { Container } from '@philips-internal/oswald-ui-core';
import { useEditorContext } from '@philips-internal/oswald-ui-core/lib/component/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, getSlot, isEnumValid } from '@philips-internal/oswald-ui-utils';
import { WizardStepSlots } from './wizard-step-constants.js';
const WizardStepContentContainer = {
    name: WizardStepSlots.CONTENT,
};
const WizardStepResultContainer = {
    name: WizardStepSlots.RESULT,
};
function getResult(children, result) {
    const childrenResult = getSlot(children, WizardStepResultContainer.name);
    if (childrenResult.length > 0) {
        return childrenResult;
    }
    if (result) {
        return result;
    }
    return null;
}
function shouldShowResult(options) {
    const { context, collapsed, done, readOnly } = options;
    if (context?.isDesigning() || (collapsed && done) || readOnly) {
        return true;
    }
    return false;
}
function shouldCollapseContent(options) {
    const { children, context, collapsed, result } = options;
    if (context?.isDesigning()) {
        return false;
    }
    if (shouldShowResult(options)) {
        return hasResult(children, result);
    }
    return collapsed;
}
function hasResult(children, result) {
    return getResult(children, result) !== null;
}
function renderContent(options) {
    const { children, collapsed, context, done, readOnly, result, uuid } = options;
    const content = getSlot(children, WizardStepContentContainer.name);
    const resultContent = getResult(children, result);
    return (React.createElement(Fragment, null,
        React.createElement(Container, { className: "c-wizard-step__content", slot: WizardStepContentContainer.name, uuid: uuid }, content),
        shouldShowResult({ collapsed, context, done, readOnly }) ? (React.createElement(Container, { className: "c-wizard-step__result", slot: WizardStepResultContainer.name, uuid: uuid }, resultContent)) : null));
}
function InternalWizardStep(props) {
    const editorContext = useEditorContext();
    const { children, className, collapsed, done, enabled, identifier, last, readOnly, stage, result, uuid, } = props;
    const shouldCollapseContentOptions = { children, collapsed, context: editorContext, done, readOnly, result };
    const renderContentOptions = { ...shouldCollapseContentOptions, children, uuid };
    const isDesigning = Boolean(editorContext?.isDesigning());
    const wizardStepClassName = classNames({
        'c-wizard-step': true,
        'c-wizard-step--collapsed': shouldCollapseContent(shouldCollapseContentOptions),
        'c-wizard-step--designing': isDesigning,
        'c-wizard-step--disabled': !enabled && !readOnly,
        'c-wizard-step--done': Boolean(done),
        'c-wizard-step--last': last,
        'c-wizard-step--read-only': readOnly,
        [`c-wizard-step--${stage}`]: isEnumValid(StepStage, stage),
        [`${className}`]: Boolean(className),
    });
    /**
     * Rendering as a container because it needs to be bordered when selected on design mode.
     * Also, empty accepted types because children slots will receive content
     */
    return (React.createElement(Container, { acceptedTypes: [], className: wizardStepClassName, "data-wizard-step-identifier": identifier, uuid: uuid },
        isDesigning
            ? React.createElement("div", { className: "c-wizard-group__title" }, MessageService.translate(props.title))
            : null,
        React.createElement("div", { className: "c-wizard-step__container" }, renderContent(renderContentOptions))));
}
export { InternalWizardStep, WizardStepContentContainer, WizardStepResultContainer, };
//# sourceMappingURL=internal-wizard-step.js.map